// === ROTACIÓN DINÁMICA DE ACCESORIOS ===
(async function() {
  const grids = document.querySelectorAll('.ctl-grid');
  if (!grids.length) return;

  // Leer las colecciones configuradas desde data attributes
  const section = document.getElementById('ctlSection');
  if (!section) return;

  // Colecciones a rotar — handles de las colecciones configuradas en el tema
  const collectionHandles = [
    section.dataset.colA,
    section.dataset.colB,
    section.dataset.colC,
    section.dataset.colD
  ].filter(Boolean);

  if (!collectionHandles.length) return;

  // Cargar productos de cada colección con paginación aleatoria
  async function fetchRandomProducts(handle, count = 4) {
    const page = Math.floor(Math.random() * 5) + 1; // páginas 1-5
    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=20&page=${page}`);
      const data = await res.json();
      const products = data.products?.filter(p => p.status === 'active') || [];
      // Mezclar aleatoriamente
      for (let i = products.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [products[i], products[j]] = [products[j], products[i]];
      }
      return products.slice(0, count);
    } catch(e) {
      return [];
    }
  }

  // Para cada look, reemplazar los items con productos aleatorios
  for (const grid of grids) {
    const items = Array.from(grid.querySelectorAll('.ctl-item'));
    if (!items.length) continue;

    // Cargar un producto aleatorio por cada colección/slot
    const promises = collectionHandles.map(handle => fetchRandomProducts(handle, 1));
    const results = await Promise.all(promises);

    items.forEach((item, idx) => {
      const product = results[idx]?.[0];
      if (!product) return;

      const variant = product.variants?.find(v => v.available) || product.variants?.[0];
      if (!variant) return;

      const image = product.images?.[0]?.src || '';
      const imageSmall = image.replace('.jpg', '_300x300.jpg').replace('.png', '_300x300.png');

      // Actualizar data attributes
      item.dataset.productId = product.id;
      item.dataset.productHandle = product.handle;
      item.dataset.productTitle = product.title;
      item.dataset.productPrice = variant.price * 100;
      item.dataset.productImage = image;
      item.dataset.tags = (product.tags || []).join('|').toLowerCase();

      // Actualizar imagen visible
      const img = item.querySelector('img');
      if (img) {
        img.src = imageSmall || image;
        img.alt = product.title;
      }
    });
  }
})();


document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('ctlSlider');
  if (!slider) return;

  let current = 0;
  const looks = Array.from(slider.querySelectorAll('.ctl-look'));
  const total = looks.length;

  looks.forEach(look => {
    const grid = look.querySelector('.ctl-grid');
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll('.ctl-item'));
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    items.forEach(item => grid.appendChild(item));
  });

  function goTo(index) {
    current = Math.max(0, Math.min(index, total - 1));
    slider.style.transform = `translateX(-${current * 100}%)`;
    document.querySelectorAll('.ctl-dot').forEach((d, i) => d.classList.toggle('active', i === current));
  }

  document.querySelectorAll('.ctl-dot').forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
  document.querySelector('.ctl-prev')?.addEventListener('click', () => goTo(current - 1));
  document.querySelector('.ctl-next')?.addEventListener('click', () => goTo(current + 1));

  let startX = 0;
  slider.addEventListener('touchstart', e => startX = e.touches[0].clientX, { passive: true });
  slider.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
  });

  let isDragging = false, dragStartX = 0, dragDelta = 0;
  slider.addEventListener('mousedown', e => { isDragging = true; dragStartX = e.clientX; });
  window.addEventListener('mousemove', e => { if (!isDragging) return; dragDelta = dragStartX - e.clientX; });
  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    if (Math.abs(dragDelta) > 60) goTo(dragDelta > 0 ? current + 1 : current - 1);
    dragDelta = 0;
  });

  // === MODAL ===
  const overlay = document.getElementById('ctlModalOverlay');
  const modal = document.getElementById('ctlModal');
  const thumbsCol = document.getElementById('ctlModalThumbs');
  const detailImg = document.getElementById('ctlModalImg');
  const detailTitle = document.getElementById('ctlModalProductTitle');
  const detailPrice = document.getElementById('ctlModalProductPrice');
  const detailVariants = document.getElementById('ctlModalVariants');
  const addBtn = document.getElementById('ctlModalAddBtn');

  let selectedVariantId = null;
  let currentLook = null;
  let allThumbItems = [];

  function openModal(look, triggerHandle) {
    currentLook = look;
    selectedVariantId = null;
    addBtn.disabled = true;
    addBtn.textContent = 'Añadir al carrito';

    const mainHandle = look.dataset.mainHandle;
    const mainTitle = look.dataset.mainTitle;
    const mainPrice = look.dataset.mainPrice;
    const mainImg = look.querySelector('.ctl-main-image img')?.src || '';
    const accessories = Array.from(look.querySelectorAll('.ctl-item'));

    allThumbItems = [];
    allThumbItems.push({ handle: mainHandle, title: mainTitle, price: mainPrice, image: mainImg });
    accessories.forEach(item => {
      allThumbItems.push({
        handle: item.dataset.productHandle,
        title: item.dataset.productTitle,
        price: item.dataset.productPrice,
        image: item.dataset.productImage
      });
    });

    thumbsCol.innerHTML = '';
    allThumbItems.forEach((item, idx) => {
      const div = document.createElement('div');
      div.className = 'ctl-modal-thumb';
      div.innerHTML = `<img src="${item.image}" alt="${item.title}" width="120" height="120" loading="lazy"><span class="ctl-thumb-plus">+</span>`;
      div.addEventListener('click', () => loadProduct(item, idx));
      thumbsCol.appendChild(div);
    });

    overlay.classList.add('open');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';

    const triggerIdx = triggerHandle
      ? allThumbItems.findIndex(i => i.handle === triggerHandle)
      : 0;
    loadProduct(allThumbItems[Math.max(0, triggerIdx)], Math.max(0, triggerIdx));
  }

  function loadProduct(item, idx) {
    selectedVariantId = null;
    addBtn.disabled = true;
    addBtn.textContent = 'Añadir al carrito';

    thumbsCol.querySelectorAll('.ctl-modal-thumb').forEach((t, i) => t.classList.toggle('active', i === idx));

    detailImg.src = item.image;
    detailTitle.textContent = item.title;
    detailPrice.textContent = '$' + (parseInt(item.price) / 100).toFixed(2);
    detailVariants.innerHTML = '<div style="font-size:11px;color:#999;padding:8px 0">Cargando...</div>';

    fetch(`/products/${item.handle}.js`)
      .then(r => r.json())
      .then(data => renderVariants(data));
  }

  function renderVariants(product) {
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      selectedVariantId = product.variants[0].id;
      addBtn.disabled = false;
      detailVariants.innerHTML = '';
      return;
    }
    let html = '';
    product.options.forEach((option, oi) => {
      const values = [...new Set(product.variants.map(v => v[`option${oi + 1}`]))];
      html += `<span class="ctl-modal-opt-label">${option.name || option}</span><div class="ctl-modal-opt-btns">`;
      values.forEach(val => {
        html += `<button class="ctl-modal-opt-btn" data-option-index="${oi}" data-value="${val}">${val}</button>`;
      });
      html += '</div>';
    });
    detailVariants.innerHTML = html;
    const selectedOptions = new Array(product.options.length).fill(null);
    detailVariants.querySelectorAll('.ctl-modal-opt-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const oi = parseInt(btn.dataset.optionIndex);
        detailVariants.querySelectorAll(`[data-option-index="${oi}"]`).forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        selectedOptions[oi] = btn.dataset.value;
        if (selectedOptions.every(o => o !== null)) {
          const variant = product.variants.find(v =>
            product.options.every((_, i) => v[`option${i + 1}`] === selectedOptions[i])
          );
          if (variant) {
            selectedVariantId = variant.id;
            addBtn.disabled = !variant.available;
          }
        }
      });
    });
  }

  function closeModal() {
    overlay.classList.remove('open');
    modal.classList.remove('open');
    document.body.style.overflow = '';
    currentLook = null;
  }

  document.querySelectorAll('.ctl-plus-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const item = btn.closest('.ctl-item');
      openModal(item.closest('.ctl-look'), item.dataset.productHandle);
    });
  });

  document.querySelectorAll('.ctl-main-plus').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      openModal(btn.closest('.ctl-look'), null);
    });
  });

  addBtn?.addEventListener('click', async () => {
    if (!selectedVariantId) return;
    addBtn.textContent = 'Agregando...';
    addBtn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(selectedVariantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error();
      const activeThumb = thumbsCol.querySelector('.ctl-modal-thumb.active');
      if (activeThumb) activeThumb.classList.add('selected-item');
      addBtn.textContent = '✓ Agregado';
      setTimeout(() => {
        addBtn.textContent = 'Añadir al carrito';
        addBtn.disabled = false;
      }, 1500);
    } catch(e) {
      addBtn.textContent = 'Error — intenta de nuevo';
      addBtn.disabled = false;
    }
  });

  overlay?.addEventListener('click', closeModal);
  document.getElementById('ctlModalClose')?.addEventListener('click', closeModal);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });
});
